module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAABJ0lEQVQ4T42TPyiGURTGf48YGWQxyCBZRMhoUP4slPUrk7IzGQwMJgPZlc2uDPJtNl8kWZD4ysKmvkVSR+ftvjpen7x3ufeent89957zXBGGmXUDC8Ak0AE8ASeSjnKZ8oWZrQLbQGs8JK3vgIqkqwwwsw1gs4mwGBqWmY0BFyXELqk7cOjpAtAAFoH7NK/Hwxy4BQZCcEnSQXhbFZhK+4YDdaA3ALOSTgMQb5ABZ8BEAG6AaUmvZjYHeElbYoZdYKXw6A/gGegrxD89wyhwWbJKL3kfasB4CWgtB4aA63+AN6AzWmMHcHv8NWYkVb+BZBGv0GATYk9SVpgi0A48Al0BOpY0/8utoVFtwDkwAuxLWv5hjbgxsx6gP/0Jb9oW8ADUJL279gs02GsvPoEGZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-address.png
// module id = OMw5
// module chunks = 0